import { render } from "./VarList.vue?vue&type=template&id=5dcdb965&scoped=true"
import script from "./VarList.vue?vue&type=script&lang=js"
export * from "./VarList.vue?vue&type=script&lang=js"

import "./VarList.vue?vue&type=style&index=0&id=5dcdb965&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcdb965"]])

export default __exports__